<div class="admin-modal">
  <h2 class="title">Reschedule booking</h2>
  <p class="subtitle">{{ data.booking.userFullName }} · currently {{ data.booking.slotStartAt | date:'EEE d MMM, HH:mm' }}</p>
  <p class="hint">The user keeps their existing payment — no re-charge. The booking returns to “pending validation” for re-confirmation.</p>

  <div *ngIf="loading" class="state">Loading available slots…</div>
  <div *ngIf="loadError" class="state error">Could not load slots. Please try again.</div>
  <div *ngIf="!loading && !loadError && slots.length === 0" class="state">No other available slots in the next 60 days.</div>

  <label class="field" *ngIf="!loading && !loadError && slots.length > 0">
    <span>New slot <em>*</em></span>
    <select name="slot" [(ngModel)]="selectedSlotId">
      <option value="" disabled selected>Choose a slot…</option>
      <option *ngFor="let s of slots" [value]="s.id">
        {{ s.startAt | date:'EEE d MMM, HH:mm' }} – {{ s.endAt | date:'HH:mm' }}
      </option>
    </select>
  </label>

  <label class="field">
    <span>Notes (optional)</span>
    <textarea name="notes" rows="2" [(ngModel)]="notes"></textarea>
  </label>

  <div class="actions">
    <button type="button" class="btn ghost" (click)="close()">Cancel</button>
    <button type="button" class="btn primary" [disabled]="!isValid" (click)="submit()">Reschedule</button>
  </div>
</div>
